import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import loginStyles from './LoginScreen.module.css';

/**
 * Login screen component
 */
const LoginScreen = ({ 
  username, 
  password, 
  setUsername,
  setPassword,
  handleLogin,
  loading,
  snackbar,
  hideSnackbar
}) => {
  return (
    <div className={loginStyles.page}>
      <header className={loginStyles.topBar}>
        <img src="/Acciona_neg.png" alt="ACCIONA" className={loginStyles.topBarLogo} />
        <div className={loginStyles.topBarDivider} />
        <span className={loginStyles.topBarSubtitle}>Artificial Intelligence System for Requirements</span>
      </header>

      <main className={loginStyles.main}>
        <div className={loginStyles.loginCard}>
          <div className={loginStyles.cardHeader}>
            <div className={loginStyles.cardHeaderInner}>
              <div className={loginStyles.cardIconBg}>
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
              </div>
              <div className={loginStyles.cardHeaderText}>
                <h2>Sign In</h2>
                <p>Enter your credentials to continue</p>
              </div>
            </div>
          </div>

          <div className={loginStyles.cardBody}>
            <form onSubmit={handleLogin}>
              <div className={loginStyles.formGroup}>
                <label htmlFor="id_username">Username</label>
                <div className={loginStyles.inputWrap}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                  <input
                    type="text"
                    id="id_username"
                    placeholder="Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                    autoFocus
                    disabled={loading}
                  />
                </div>
              </div>

              <div className={loginStyles.formGroup}>
                <label htmlFor="id_password">Password</label>
                <div className={loginStyles.inputWrap}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                  <input
                    type="password"
                    id="id_password"
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    disabled={loading}
                  />
                </div>
              </div>

              <button type="submit" className={loginStyles.btnSubmit} disabled={loading}>
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
                  <polyline points="10 17 15 12 10 7"/>
                  <line x1="15" y1="12" x2="3" y2="12"/>
                </svg>
                {loading ? 'Signing in...' : 'Access Platform'}
              </button>
            </form>
          </div>

          <div className={loginStyles.cardFooter}>
            © 2026 ACCIONA - Artificial Intelligence System for Requirements
          </div>
        </div>
      </main>

      <footer className={loginStyles.pageFooter}>
        <p>© 2026 ACCIONA. All rights reserved.</p>
      </footer>

      <Snackbar 
        open={snackbar?.open || false} 
        autoHideDuration={6000} 
        onClose={hideSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert 
          onClose={hideSnackbar} 
          severity={snackbar?.severity || 'error'} 
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbar?.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default LoginScreen;
